import React from "react";

const NailArtNearMeBenefits = () => {
  return (
    <div className="hairSalonNearMeService">
      <h3>The Benefits of Nail Art Near Me</h3>
      <p>
        Getting nail art near me isn’t just about aesthetics—it comes with
        plenty of benefits:
      </p>

      <li>
        <h6> Boosts Confidence</h6>
        <p>
          When your nails look great, you feel great! Whether it's a pop of
          color, fun designs, or a chic minimalist look, beautiful nails can
          boost your self-confidence and make you feel more polished.
        </p>
      </li>
      <li>
        <h6> A Form of Self-Expression</h6>
        <p>
          Nail art is one of the easiest and most fun ways to express yourself.
          From bold statements to delicate designs, your nails are a blank
          canvas waiting to reflect your personality.
        </p>
      </li>
      <li>
        <h6> A Treat for Yourself</h6>
        <p>
          Self-care is essential, and getting your nails done is a wonderful way
          to relax and unwind. Nail art allows you to treat yourself to a fun
          experience while giving your hands the attention they deserve.
        </p>
      </li>
    </div>
  );
};

export default NailArtNearMeBenefits;
